module.exports = __webpack_public_path__ + "img/pos1-bg.62a60d8b.jpg";